import React from 'react';
import classNames from 'classnames';
import Button from '../Button';
import FontAwesomeIcon from '../Icon';

interface DocumentProps {
  active?: any;
  headline?: any;
  strapline?: any;
  itemName?: any;
  itemTypeWalkthrough?: any;
  image?: any;
  onDownload?: any;
  icon?: any;
  small?: any;
  onView?: any;
  onDelete?: any;
  check?: any;
  onClick?: any;
  edit?: any;
  onEdit?: any;
  adaptiveSize?: any;
  from?: any;
}

const Document = ({
  active,
  headline,
  strapline,
  itemName,
  itemTypeWalkthrough,
  image,
  onDownload,
  icon,
  small,
  onView,
  onDelete,
  check,
  onClick,
  edit,
  onEdit,
  adaptiveSize = false,
}: DocumentProps) => {
  return (
    <div
      className={classNames('documents__item', {
        'documents__item--active': active,
        'documents__item--small': small,
        'documents__item--fixed_document_width': !adaptiveSize,
      })}
      onClick={() => (onClick ? null : onDownload ? onDownload() : null)}
    >
      <div className="documents__delete">
        {image ? (
          <Button
            style={{ marginRight: '.25em' }}
            color="semantic"
            label={<FontAwesomeIcon glyph="download" weight="light" />}
            onClick={() =>
              onDownload && image !== null ? onDownload(image) : null
            }
          />
        ) : null}
        {onView ? (
          <Button
            style={{ marginRight: '.25em' }}
            color="semantic"
            label={<FontAwesomeIcon glyph="eye" weight="light" />}
            onClick={() => onView()}
          />
        ) : null}
        {edit ? (
          <Button
            style={{ marginRight: '.25em' }}
            color="semantic"
            label={<FontAwesomeIcon glyph="pencil" weight="light" />}
            onClick={() => onEdit()}
          />
        ) : null}
        {onDelete ? (
          <Button
            color="semantic"
            label={<FontAwesomeIcon glyph="trash" weight="light" />}
            onClick={() => onDelete()}
          />
        ) : null}
      </div>
      <div>
        <div
          className={classNames('documents__icon', {
            'documents__icon--delete': onDelete ? true : false,
          })}
          onClick={() => (onClick ? onClick() : null)}
        >
          {icon ? (
            icon
          ) : (
            <FontAwesomeIcon weight="light" glyph="file-contract" />
          )}
        </div>
        {headline && (
          <div
            className="documents__details"
            onClick={() => (onClick ? onClick() : null)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className="documents__headline" title={headline}>
                {headline}
              </div>
              {check === true ? (
                <div className="documents__headline--checkIcon">
                  <FontAwesomeIcon weight="regular" glyph="check-circle" />
                </div>
              ) : check === false ? (
                <div className="documents__headline--infoIcon">
                  <FontAwesomeIcon weight="regular" glyph="info-circle" />
                </div>
              ) : null}
            </div>
            <div className="documents__strapline" title={strapline}>
              {strapline}
            </div>
            <div className="documents__strapline" title={itemName}>
              {itemName}
            </div>
            {itemTypeWalkthrough ? (
              <div className="documents__itemType" title={itemTypeWalkthrough}>
                {itemTypeWalkthrough}
              </div>
            ) : (
              <div />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Document;
